import report from "@report";
import { copyToClipboard } from "@utils/copy";
import { message } from "antd";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import "./index.scss";
import { getReportSearchType } from "@utils/util";

const CopyBtn = ({
  text,
  className,
  pos,
  disable,
}: {
  text: string | number;
  className?: string;
  pos?: string;
  disable?: boolean;
}) => {
  const { t } = useTranslation();

  if (disable) {
    return <div className="copy-btn__icon copy-btn__icon--disable" />;
  }

  return (
    <div
      className={classNames(
        "copy-btn shrink-0 cursor-pointer hover:bg-[#EEE] rounded-[2px] flex items-center",
        className,
      )}
      onClick={(e) => {
        e.stopPropagation();
        copyToClipboard(text + "").then(() => {
          message.success(t("Copy succeed"));
          if (typeof pos === "string" && !!pos) {
            report.event("copy_content", {
              kalo_type: getReportSearchType(),
              kalo_pos: pos,
              kalo_value: text,
            });
          }
        });
      }}
    >
      <div className="copy-btn__icon" />
    </div>
  );
};

export default CopyBtn;
